import * as React from 'react';
function IconArrowDown(props) {
    return (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-xds": "IconArrowDown", ...props },
        React.createElement("path", { d: "M5.468 7L4 8.468l8 8 8-8L18.532 7 12 13.532 5.468 7z", fill: "currentColor" })));
}
export default IconArrowDown;
//# sourceMappingURL=IconArrowDown.js.map